import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const Contact = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <h2 className="text-4xl md:text-5xl font-bold text-notaria-primary mb-4">
            El cambio comienza con una conversación
          </h2>
          <h3 className="text-2xl text-gray-700 mb-4">
            ¿Tienes un desafío o una idea?
          </h3>
          <p className="text-gray-600 max-w-3xl mx-auto mb-8">
            En Notaría 90 te ofrecemos asesorías personalizadas para resolver tus trámites con total 
            confianza y respaldo jurídico. Déjanos tus datos y nos pondremos en contacto contigo para 
            brindarte la atención que mereces.
          </p>

          {/* Contact Button */}
          <Link to="/contacto">
            <Button className="bg-notaria-secondary hover:bg-notaria-primary text-white px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300 hover:scale-105">
              Contáctanos
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Contact;
